import { render, staticRenderFns } from "./ProfileDocuments.vue?vue&type=template&id=48aaa61f&scoped=true&"
import script from "./ProfileDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDocuments.vue?vue&type=style&index=0&id=48aaa61f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aaa61f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48aaa61f')) {
      api.createRecord('48aaa61f', component.options)
    } else {
      api.reload('48aaa61f', component.options)
    }
    module.hot.accept("./ProfileDocuments.vue?vue&type=template&id=48aaa61f&scoped=true&", function () {
      api.rerender('48aaa61f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ProfileDocuments.vue"
export default component.exports